import { useMutation, useQuery } from 'react-query';

import { useSecurePortalFetcher } from '../../../../shared/hooks';
import { Count, UseReactQueryOptions } from '../../../../shared/models';
import { Resource } from '../../common/models';

export const useFavouritesQuery = (
  options?: UseReactQueryOptions<Resource>
) => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(
    ['favourites'],
    async () => {
      const { data } = await fetcher<Resource>('/v1/favourites').json();

      return data;
    },
    options
  );
};

export const useFavouritesCountQuery = () => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(['favourites-count'], async () => {
    const { data } = await fetcher<Count>('/v1/favourites/count').json();

    return data;
  });
};

export const useToggleFavourite = () => {
  const fetcher = useSecurePortalFetcher();
  return useMutation(
    async ({ id, isFolder }: { id: string; isFolder: boolean }) => {
      const { data } = await fetcher<{ isFavourite: boolean }>(
        `/v1/${isFolder ? 'folders' : 'documents'}/${id}/favourite`,
        {
          method: 'POST',
        }
      ).json();
      return data;
    }
  );
};
